module.exports = __webpack_public_path__ + "img/contactItem2.c97124fe.png";